// extracted by mini-css-extract-plugin
module.exports = {"overviewSearch":"OverviewTextFilter_overviewSearch__OPJtT"};